import React, { useContext } from "react";
import ScrollTo from "./ScrollTo";
import H1 from "./H1";
import H2 from "./H2";
import H3 from "./H3";
import H5 from "./H5";
import PreferencesContext from "../../contexts/preferences";
import LaunchGame from "./LaunchGame";
import { Section, Wrapper } from "./GetStartedNow.style";

const GetStartedNow = ({ scrollTo }) => {
  const { inGame } = useContext(PreferencesContext);

  return (
    <Section id="getting-started" inGame={inGame}>
      <Wrapper inGame={inGame}>
        {/* <Wuzzits>
          <ResearchBadge width={220} height={220} />
        </Wuzzits> */}

        {!inGame && (
          <React.Fragment>
            <H1>Develop your family's true math potential</H1>
            <H3>
              Increase math problem-solving skills by nearly 20% with just three
              10-minute sessions per week
            </H3>
            <H2></H2>
          </React.Fragment>
        )}

        {inGame && (
          <React.Fragment>
            <H2>Join Now!</H2>
            <H5>
              A BrainQuake subscription provides you with access to our number
              sense, algebraic thinking and proportional reasoning puzzles, the
              BrainQuake Score &trade; and future content.
            </H5>
          </React.Fragment>
        )}

        {/*{!inGame && (
          <React.Fragment>
            <ChildSafe>
              <div className="left">
                <div>
                  <div>
                    <div>
                      <span className="dollar-sign">$</span>
                      <span className="dollars">7</span>
                    </div>
                    <div className="cents">99</div>
                  </div>

                  <div>per month</div>
                </div>
              </div>
              <img className="logo" src={imgSafe} alt="Safe" />
              <div className="right">
                <div>Supports up to</div>
                <div className="number">3 players</div>
                <div style={{ fontSize: '0.85em' }}>for the price of 1!</div>
              </div>
            </ChildSafe>
          </React.Fragment>
        )}

        {inGame && (
          <React.Fragment>
            <ChildSafe>
              <div className="left">
                Less than the average price of 90 min of private tutoring.
              </div>
              <img className="logo" src={imgSafe} alt="Safe" />
              <div className="right">
                <div>Supports up to</div>
                <div className="number">3 players</div>
                <div style={{ fontSize: '0.85em' }}>for the price of 1!</div>
              </div>
            </ChildSafe>

            <H5>
              <b>Try 30 days for FREE.</b>
            </H5>
            <H5 style={{ marginBottom: 34 }}>
              Then $7.99 / month or $76.99 per year, a 20% savings.
            </H5>
          </React.Fragment>
        )}*/}

        {/* Button 
        {/*{inGame && (
          <React.Fragment>
            <div>
              <StyledGreenButton
                onClick={() =>
                  !inGame
                    ? history.push(routes.getStarted)
                    : (window.location.href =
                        'uniwebview://purchase_monthly_sub')
                }
              >
                $7.99 / Month
              </StyledGreenButton>
            </div>
            <div>
              <StyledGreenButton
                onClick={() =>
                  !inGame
                    ? history.push(routes.getStarted)
                    : (window.location.href =
                        'uniwebview://purchase_yearly_sub')
                }
              >
                $76.99 / year, a 20% savings
              </StyledGreenButton>
            </div>
          </React.Fragment>
        )}*/}

        {!inGame && <LaunchGame style={{ marginBottom: 64 }} />}
      </Wrapper>

      {scrollTo && <ScrollTo selector={scrollTo} />}
    </Section>
  );
};

export default GetStartedNow;
